import { render, staticRenderFns } from "./EditView.vue?vue&type=template&id=db6e23f0&scoped=true&"
import script from "./EditView.vue?vue&type=script&lang=ts&"
export * from "./EditView.vue?vue&type=script&lang=ts&"
import style0 from "./EditView.vue?vue&type=style&index=0&id=db6e23f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6e23f0",
  null
  
)

export default component.exports